<div class="max-w-[1280px] mx-auto igntr-theme bg-[--background-color]">
  <div class="p-7 space-y-5">
    <div class="flex items-start justify-between mb-4">
      <div class="flex items-start gap-2.5">
        <div
          class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
        >
          <igntr-icon name="database"></igntr-icon>
        </div>
        <div>
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ "spDescription" | transloco }}
          </div>
          <div class="text-[12px] !text-slate-500 mt-0.5">
            {{ "spPattern" | transloco }}
          </div>
        </div>
      </div>
      <button
        (click)="save()"
        class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium"
      >
        {{ "save" | transloco }}
      </button>
    </div>

    <div class="rounded-xl border !border-slate-200/70 bg-white">
      <div *ngIf="selectedCategories.length > 0" class="px-3.5 py-3">
        <span class="text-[14px] font-bold !text-slate-700">{{
          "strategicLayerInputs" | transloco
        }}</span>

        <div
          *ngFor="let category of selectedCategories"
          class="px-3.5 py-3 border-b !border-slate-100"
        >
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              category.name | transloco
            }}</span>
          </div>

          <textarea
            rows="3"
            type="text"
            class="w-full text-[14px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
            autocomplete="off"
            [(ngModel)]="category.description"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </div>
      </div>
      <div *ngIf="selectedCategoriesDepartment.length > 0" class="px-3.5 py-3">
        <span class="text-[14px] font-bold !text-slate-700">{{
          "tacticalLayerInputs" | transloco
        }}</span>
        <div
          *ngFor="let category of selectedCategoriesDepartment"
          class="px-3.5 py-3 border-b !border-slate-100"
        >
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              category.name | transloco
            }}</span>
          </div>

          <textarea
            rows="3"
            type="text"
            class="w-full text-[14px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
            autocomplete="off"
            [(ngModel)]="category.description"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </div>
      </div>
      <div *ngIf="selectedCategoriesOperational.length > 0" class="px-3.5 py-3">
        <span class="text-[14px] font-bold !text-slate-700">{{
          "operationalLayerInputs" | transloco
        }}</span>
        <div
          *ngFor="let category of selectedCategoriesOperational"
          class="px-3.5 py-3 border-b !border-slate-100 last:border-b-0"
        >
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium !text-slate-700">{{
              category.name | transloco
            }}</span>
          </div>
          <textarea
            rows="3"
            type="text"
            class="w-full text-[14px] !text-slate-800 bg-slate-50 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 resize-none"
            autocomplete="off"
            [(ngModel)]="category.description"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
